
<!-- Template -->
<template>
</template>

<style>

</style>

<!-- Script -->
<script>
import services from '../services/service'; // Service Class
let service = new services();

export default {
  name: "Ref",
  data() {
      return {
         }
  },
  methods: {
    },
    created: function(){
       if(this.$route.params.refno){
        let arr_ref = this.$route.params.refno;
        var arr = arr_ref.split("ref");
        localStorage.setItem("cityneeds_ref", arr[1]);
        //    this.$router.push("/"); 
        location.replace("/")
        }
    }
}
</script>




// WEBPACK FOOTER //
// Ref.vue?385585cc